// import axios from "axios";
import { CONFIG } from "../../config";
import { axios } from "../../interceptors";

const validateUser = async (data) => {
  try {
    const res = await axios({
      url: `${CONFIG.API_URL}/validate-user`,
      method: "POST",
      data
    });
    return res.data;
  } catch (error) {
    return (handleError(error));
  }
};

const handleError = err => {
  console.log(`Api call error in services -> request.js : `, err);
};

export const _auth = {
  validateUser
};
